<ng-template #autocomplete>
  <div
    class="autocomplete-wrapper"
    [@fadeInOut]="animationState"
    [style.pointer-events]="animationState === 'visible' ? 'auto' : 'none'"
  >
    <div class="autocomplete-container">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
